(()=>{
  function init(root){
    if(!root||root.dataset.bdaReady)return;
    root.dataset.bdaReady='true';
    const section=root.closest('.shopify-section');
    const data=JSON.parse(section.querySelector('[data-bda-categories]').textContent);
    const entityMap={'&amp;':'&','&quot;':'"','&#39;':"'",'&#x27;':"'",'&apos;':"'",'&lt;':'<','&gt;':'>'};
    const decode=value=>value.replace(/&(?:amp|quot|#39|#x27|apos|lt|gt);/g,entity=>entityMap[entity]);
    Object.values(data).forEach(group=>Object.keys(group).forEach(name=>{if(typeof group[name]==='string')group[name]=decode(group[name]);}));
    root.querySelectorAll('#BDHomeCategory option').forEach(option=>{option.value=decode(option.value);});
    const menu=root.querySelector('.bd-menu-button');
    const mobile=root.querySelector('#bd-home-mobile-menu');
    const form=root.querySelector('#BDHomeContactForm');
    const toggle=root.querySelector('[data-quote-toggle]');
    const contact=root.querySelector('#bd-home-contact');
    const openQuote=()=>{form.classList.add('is-open');toggle.setAttribute('aria-expanded','true');};
    menu.addEventListener('click',()=>{
      const open=menu.getAttribute('aria-expanded')==='true';
      menu.setAttribute('aria-expanded',String(!open));
      menu.setAttribute('aria-label',open?data.labels.openMenu:data.labels.closeMenu);
      mobile.hidden=open;
    });
    root.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
      const target=root.querySelector(link.getAttribute('href'));
      if(!target)return;
      event.preventDefault();
      if(target===form)openQuote();
      (target===form?contact:target).scrollIntoView({behavior:'auto',block:'start'});
      mobile.hidden=true;menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',data.labels.openMenu);
    }));
    const params=new URLSearchParams(location.search);
    const product=params.get('bd_product');
    const category=params.get('bd_category');
    if(category){const select=root.querySelector('#BDHomeCategory');if([...select.options].some(option=>option.value===category))select.value=category;}
    if(product){const details=root.querySelector('#BDHomeDetails');if(!details.value)details.value=product;openQuote();}
    toggle.addEventListener('click',()=>{const open=form.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
    if(form.querySelector('[data-bda-result]')||location.hash==='#BDHomeContactForm'){openQuote();contact.scrollIntoView({behavior:'auto',block:'start'});}
  }
  document.querySelectorAll('[data-bda-home]').forEach(init);
  document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-bda-home]')));
})();

